import { Prop } from '@typegoose/typegoose'
import { Field, Float, ObjectType } from 'type-graphql'

/** One priced invoice line of a tenant: the unit price, its discount and the quantity it applies to. */
@ObjectType()
export class TenantPricingRate {
  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  rate?: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  discount?: number

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number })
  quantity?: number
}

/** The pricing of the five invoice lines PayMe bills the tenant for. */
@ObjectType()
export class TenantInvoicePricing {
  @Field(() => TenantPricingRate, { nullable: true })
  @Prop({ type: TenantPricingRate })
  weightOfMonth?: TenantPricingRate

  @Field(() => TenantPricingRate, { nullable: true })
  @Prop({ type: TenantPricingRate })
  activeProducers?: TenantPricingRate

  @Field(() => TenantPricingRate, { nullable: true })
  @Prop({ type: TenantPricingRate })
  monthlySubscription?: TenantPricingRate

  @Field(() => TenantPricingRate, { nullable: true })
  @Prop({ type: TenantPricingRate })
  weightCappingBase?: TenantPricingRate

  @Field(() => TenantPricingRate, { nullable: true })
  @Prop({ type: TenantPricingRate })
  weightCappingExcess?: TenantPricingRate
}
